// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__HDMyb","log":"ModalInventoryLogs_log__18A7O","date":"ModalInventoryLogs_date__1j2Mw","userName":"ModalInventoryLogs_userName__3qPKu"};